import switchToDomain from './switchToDomain';

export default switchToDomain;
